export default __webpack_public_path__ + "static/media/parc5.d69daabc.jpg";